module.exports = __webpack_public_path__ + "static/media/doublebed2_s.a706b772.jpg";